export enum Language {
  English = "en",
  German = "de",
}

export enum TranslationKey {
  Apple = "apple",
  Anchor = "anchor",
  Birdie = "birdie",
  Bolt = "bolt",
  Bomb = "bomb",
  Bottle = "bottle",
  Cactus = "cactus",
  Candle = "candle",
  Car = "car",
  Carrot = "carrot",
  Cheese = "cheese",
  ChessKnight = "chess_knight",
  Clock = "clock",
  Clover = "clover",
  Clown = "clown",
  Daisy = "daisy",
  Dinosaur = "dinosaur",
  Dobble = "dobble",
  Dog = "dog",
  Dolphin = "dolphin",
  Dragon = "dragon",
  ExclamationMark = "exclamation_mark",
  Eye = "eye",
  Fire = "fire",
  Ghost = "ghost",
  Glasses = "glasses",
  Hammer = "hammer",
  Heart = "heart",
  Icecube = "icecube",
  Igloo = "igloo",
  Key = "key",
  Kitty = "kitty",
  Ladybug = "ladybug",
  Lightbulb = "lightbulb",
  Lips = "lips",
  Man = "man",
  MapleLeaf = "maple_leaf",
  Moon = "moon",
  Net = "net",
  NoEntry = "no_entry",
  Padlock = "padlock",
  Pencil = "pencil",
  QuestionMark = "question_mark",
  Scissors = "scissors",
  Skull = "skull",
  Snowflake = "snowflake",
  Snowman = "snowman",
  Spider = "spider",
  Spots = "spots",
  Sun = "sun",
  Target = "target",
  TrebleClef = "treble_clef",
  Tree = "tree",
  Turtle = "turtle",
  Waterdrop = "waterdrop",
  YinYang = "yin_yang",
  Zebra = "zebra",
}

export const translations: Record<Language, Record<TranslationKey, string>> = {
  [Language.English]: {
    [TranslationKey.Apple]: "Apple",
    [TranslationKey.Anchor]: "Anchor",
    [TranslationKey.Birdie]: "Birdie",
    [TranslationKey.Bolt]: "Bolt",
    [TranslationKey.Bomb]: "Bomb",
    [TranslationKey.Bottle]: "Bottle",
    [TranslationKey.Cactus]: "Cactus",
    [TranslationKey.Candle]: "Candle",
    [TranslationKey.Car]: "Car",
    [TranslationKey.Carrot]: "Carrot",
    [TranslationKey.Cheese]: "Cheese",
    [TranslationKey.ChessKnight]: "Chess knight",
    [TranslationKey.Clock]: "Clock",
    [TranslationKey.Clover]: "Clover",
    [TranslationKey.Clown]: "Clown",
    [TranslationKey.Daisy]: "Daisy",
    [TranslationKey.Dinosaur]: "Dinosaur",
    [TranslationKey.Dobble]: "Dobble",
    [TranslationKey.Dog]: "Dog",
    [TranslationKey.Dolphin]: "Dolphin",
    [TranslationKey.Dragon]: "Dragon",
    [TranslationKey.ExclamationMark]: "Exclamation mark",
    [TranslationKey.Eye]: "Eye",
    [TranslationKey.Fire]: "Fire",
    [TranslationKey.Ghost]: "Ghost",
    [TranslationKey.Glasses]: "Glasses",
    [TranslationKey.Hammer]: "Hammer",
    [TranslationKey.Heart]: "Heart",
    [TranslationKey.Icecube]: "Icecube",
    [TranslationKey.Igloo]: "Igloo",
    [TranslationKey.Key]: "Key",
    [TranslationKey.Kitty]: "Kitty",
    [TranslationKey.Ladybug]: "Ladybug",
    [TranslationKey.Lightbulb]: "Lightbulb",
    [TranslationKey.Lips]: "Lips",
    [TranslationKey.Man]: "Man",
    [TranslationKey.MapleLeaf]: "Maple leaf",
    [TranslationKey.Moon]: "Moon",
    [TranslationKey.Net]: "Net",
    [TranslationKey.NoEntry]: "No entry",
    [TranslationKey.Padlock]: "Padlock",
    [TranslationKey.Pencil]: "Pencil",
    [TranslationKey.QuestionMark]: "Question mark",
    [TranslationKey.Scissors]: "Scissors",
    [TranslationKey.Skull]: "Skull",
    [TranslationKey.Snowflake]: "Snowflake",
    [TranslationKey.Snowman]: "Snowman",
    [TranslationKey.Spider]: "Spider",
    [TranslationKey.Spots]: "Spots",
    [TranslationKey.Sun]: "Sun",
    [TranslationKey.Target]: "Target",
    [TranslationKey.TrebleClef]: "Treble Clef",
    [TranslationKey.Tree]: "Tree",
    [TranslationKey.Turtle]: "Turtle",
    [TranslationKey.Waterdrop]: "Eaterdrop",
    [TranslationKey.YinYang]: "Yin Yang",
    [TranslationKey.Zebra]: "Zebra",
  },
  [Language.German]: {
    [TranslationKey.Apple]: "Apfel",
    [TranslationKey.Anchor]: "Anker",
    [TranslationKey.Birdie]: "Vogel",
    [TranslationKey.Bolt]: "Blitz",
    [TranslationKey.Bomb]: "Bombe",
    [TranslationKey.Bottle]: "Flasche",
    [TranslationKey.Cactus]: "Cactus",
    [TranslationKey.Candle]: "Kerze",
    [TranslationKey.Car]: "Auto",
    [TranslationKey.Carrot]: "Karrotte",
    [TranslationKey.Cheese]: "Käse",
    [TranslationKey.ChessKnight]: "Pferd",
    [TranslationKey.Clock]: "Uhr",
    [TranslationKey.Clover]: "Cleeblatt",
    [TranslationKey.Clown]: "Clown",
    [TranslationKey.Daisy]: "Gänseblümchen",
    [TranslationKey.Dinosaur]: "Dinosaure",
    [TranslationKey.Dobble]: "Hand",
    [TranslationKey.Dog]: "Hund",
    [TranslationKey.Dolphin]: "Delphine",
    [TranslationKey.Dragon]: "Drachen",
    [TranslationKey.ExclamationMark]: "Ausrufezeichen",
    [TranslationKey.Eye]: "Auge",
    [TranslationKey.Fire]: "Feuer",
    [TranslationKey.Ghost]: "Gheist",
    [TranslationKey.Glasses]: "Brille",
    [TranslationKey.Hammer]: "Hammer",
    [TranslationKey.Heart]: "Herz",
    [TranslationKey.Icecube]: "Eis",
    [TranslationKey.Igloo]: "Igloo",
    [TranslationKey.Key]: "Schlüssel",
    [TranslationKey.Kitty]: "Katze",
    [TranslationKey.Ladybug]: "Marienkäfer",
    [TranslationKey.Lightbulb]: "Glühbirne",
    [TranslationKey.Lips]: "Lippen",
    [TranslationKey.Man]: "Orangen Mann",
    [TranslationKey.MapleLeaf]: "Ahorn Blatt",
    [TranslationKey.Moon]: "Mond",
    [TranslationKey.Net]: "Netz",
    [TranslationKey.NoEntry]: "Kein Zutritt",
    [TranslationKey.Padlock]: "Schloss",
    [TranslationKey.Pencil]: "Bleistift",
    [TranslationKey.QuestionMark]: "Fragezeichen",
    [TranslationKey.Scissors]: "Schere",
    [TranslationKey.Skull]: "Toten Kopf",
    [TranslationKey.Snowflake]: "Schneeflocke",
    [TranslationKey.Snowman]: "Schneemann",
    [TranslationKey.Spider]: "Spinne",
    [TranslationKey.Spots]: "Flecke",
    [TranslationKey.Sun]: "Sonne",
    [TranslationKey.Target]: "Fadenkreuz",
    [TranslationKey.TrebleClef]: "Notenschlüssel",
    [TranslationKey.Tree]: "Baum",
    [TranslationKey.Turtle]: "Schildkröte",
    [TranslationKey.Waterdrop]: "Wassertropfen",
    [TranslationKey.YinYang]: "Yin Yang",
    [TranslationKey.Zebra]: "Zebra",
  },
};
